// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import API_BASE_URL from '../components/baseurl';
// const ProductList = () => {
//     const [products, setProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchProducts = async () => {
//             try {
//                 const response = await axios.get(`${API_BASE_URL}`);
//                 setProducts(response.data);
//             } catch (err) {
//                 setError(err.message || 'Failed to fetch products');
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchProducts();
//     }, []);

//     if (loading) return <div className="d-flex justify-content-center align-items-center vh-100">
//       <div className="text-center">
//         <div className="spinner-border text-primary mb-3" role="status" style={{ width: '4rem', height: '4rem' }}>
//           <span className="visually-hidden">Loading...</span>
//         </div>
//         <h4 className="text-secondary">Loading Products...</h4>
//       </div>
//     </div>;
//     if (error) return <div>Error: {error}</div>;

//     return (
//         <div>
//             <h1 style={{textAlign:'center',marginTop:'10vh'}}>Product List</h1>
//             {products.length === 0 ? (
//                 <p>No products found.</p>
//             ) : (
//             //     <ul>
//             //         {products.map((product) => (
//             //             <li key={product.id}>
//             //                 <h5>{product.name}</h5>
//             //                 <p>{product.description}</p>
//             //                 <p>Price: ${product.price}</p>
//             //                 <p>Created: {new Date(product.created_at).toLocaleString()}</p>
//             //                 <p>Updated: {new Date(product.updated_at).toLocaleString()}</p>
//             //             </li>
//             //         ))}
//             //     </ul>
//             <div className="row row-cols-auto m-5">
//                 <div className="card-group" style={{ justifyContent: 'center'}}>
//                     {products.map((product) => (
//                         <div className='col' key={product.id}>
//                         <div className="card m-3"  style={{ width: '15rem'}}>
//                             <div className="card-body">
//                                 <h5 className="card-title">{product.name}</h5>
//                                 <h6 className="card-subtitle mb-2 text-body-secondary">{product.description}</h6>
//                                 <p className="card-text">Price: ${product.price}</p>
//                                 <p className="card-text">Created: {new Date(product.created_at).toLocaleString()}</p>
//                                 <p className="card-text">Updated: {new Date(product.updated_at).toLocaleString()}</p>
//                             </div>
//                         </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//             )}
//         </div>
//     );
// };

// const CreateProduct = () => {
//     const [name, setName] = useState('');
//     const [description, setDescription] = useState('');
//     const [price, setPrice] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [success, setSuccess] = useState(false);

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         setLoading(true);
//         setError(null);
//         setSuccess(false);

//         if (!name.trim() || !description.trim() || !price) {
//             setError('Please fill in all fields.');
//             setLoading(false);
//             return;
//         }

//         const priceNum = Number(price);
//         if (isNaN(priceNum) || priceNum <= 0) {
//             setError('Price must be a valid positive number.');
//             setLoading(false);
//             return;
//         }

//         const productData = {
//             name: name.trim(),
//             description: description.trim(),
//             price: priceNum,
//         };

//         try {
//             const response = await axios.post(`${API_BASE_URL}`, productData);
//             console.log('Product created:', response.data);
//             setSuccess(true);
//             setName('');
//             setDescription('');
//             setPrice('');
//         } catch (err) {
//             if (axios.isAxiosError && err.response) {
//                 setError(`Server error: ${err.response.status} - ${JSON.stringify(err.response.data)}`);
//             } else {
//                 setError(`Error: ${err.message || 'Unexpected error'}`);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div>
//             <form onSubmit={handleSubmit} style={{ width: '300px',height: '300px',margin: 'auto' }}>
//                 <div>
//                     <label htmlFor="name" className="form-label">Name:</label>
//                     <input
//                         className="form-control"
//                         type="text"
//                         id="name"
//                         value={name}
//                         onChange={(e) => setName(e.target.value)}
//                     />
//                 </div>
//                 <div>
//                     <label htmlFor="description" className="form-label">Description:</label>
//                     <textarea
//                         className="form-control"
//                         id="description"
//                         value={description}
//                         onChange={(e) => setDescription(e.target.value)}
//                     />
//                 </div>
//                 <div>
//                     <label htmlFor="price" className="form-label">Price:</label>
//                     <input
//                         className="form-control"
//                         type="text"
//                         id="price"
//                         value={price}
//                         onChange={(e) => setPrice(e.target.value)}
//                     />
//                 </div>
//                 <button type="submit" disabled={loading} className="btn btn-dark" style={{ margin:'10vh 0' }}>
//                     {loading ? 'Creating...' : 'Create Product'}
//                 </button>
//             </form>
//             {error && <p style={{ color: 'red' }}>{error}</p>}
//             {success && <p style={{ color: 'green' }}>Product created successfully!</p>}
//         </div>
//     );
// };
// const Product = () => {
//     const [showCreateForm, setShowCreateForm] = useState();
//      return ( <div>
//  <h1 style={{textAlign:'center'}}>Create Product</h1>
//             <button onClick={() => setShowCreateForm(!showCreateForm)} className="btn btn-primary" style={{ justifyContent: 'center', display: 'block', margin: '0 auto' }}>
//                 {showCreateForm ? 'Hide Form' : 'Create New Product'}
//             </button>
//             {showCreateForm && <CreateProduct />}
//             <div>
//             <ProductList />
//             </div>
//         </div>
//     );}
//     export default Product;
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../components/baseurl';
import './product.css';  // Custom CSS for hover effects

const ProductList = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}`);
                setProducts(response.data);
            } catch (err) {
                setError(err.message || 'Failed to fetch products');
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light loading-overlay">
                <div className="text-center">
                    <div className="spinner-border text-primary mb-3" role="status" style={{ width: '4rem', height: '4rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <h4 className="text-secondary">Loading Products...</h4>
                </div>
            </div>
        );
    }

    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container py-4">
            <h2 className="text-center mb-4">Product List</h2>
            {products.length === 0 ? (
                <p className="text-center">No products found.</p>
            ) : (
                <div className="row g-4">
                    {products.map((product) => (
                        <div className="col-md-4" key={product.id}>
                            <div
                                className="product-card position-relative rounded shadow"
                                style={{ backgroundImage: `url(${product.image})` }}
                            >
                                <div className="product-overlay p-3 d-flex flex-column justify-content-end">
                                    <h5 className="text-white mb-1">{product.name}</h5>
                                    <p className="text-white mb-1">{product.description}</p>
                                    <p className="text-white fw-bold">Price: ${product.price}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const CreateProduct = () => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState('');
    const [image, setImage] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        if (!name.trim() || !description.trim() || !price || !image.trim()) {
            setError('Please fill in all fields.');
            setLoading(false);
            return;
        }

        const priceNum = Number(price);
        if (isNaN(priceNum) || priceNum <= 0) {
            setError('Price must be a valid positive number.');
            setLoading(false);
            return;
        }

        const productData = {
            name: name.trim(),
            description: description.trim(),
            price: priceNum,
            image: image.trim(),  // Cloudinary URL
        };

        try {
            const response = await axios.post(`${API_BASE_URL}`, productData);
            console.log('Product created:', response.data);
            setSuccess(true);
            setName('');
            setDescription('');
            setPrice('');
            setImage('');
        } catch (err) {
            if (axios.isAxiosError && err.response) {
                setError(`Server error: ${err.response.status} - ${JSON.stringify(err.response.data)}`);
            } else {
                setError(`Error: ${err.message || 'Unexpected error'}`);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="my-4">
            <form onSubmit={handleSubmit} className="p-4 border rounded mx-auto" style={{ maxWidth: '400px' }}>
                <h4 className="text-center mb-3">Create New Product</h4>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">Name:</label>
                    <input
                        className="form-control"
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="description" className="form-label">Description:</label>
                    <textarea
                        className="form-control"
                        id="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="price" className="form-label">Price:</label>
                    <input
                        className="form-control"
                        type="text"
                        id="price"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="image" className="form-label">Cloudinary Image URL:</label>
                    <input
                        className="form-control"
                        type="text"
                        id="image"
                        value={image}
                        onChange={(e) => setImage(e.target.value)}
                        placeholder="Paste Cloudinary image URL"
                    />
                </div>
                <button type="submit" disabled={loading} className="btn btn-dark w-100">
                    {loading ? 'Creating...' : 'Create Product'}
                </button>
                {error && <p className="text-danger mt-3">{error}</p>}
                {success && <p className="text-success mt-3">Product created successfully!</p>}
            </form>
        </div>
    );
};

const Product = () => {
    const [showCreateForm, setShowCreateForm] = useState(false);

    return (
        <div>
            <button
                onClick={() => setShowCreateForm(!showCreateForm)}
                className="btn btn-primary my-4 d-block mx-auto"
            >
                {showCreateForm ? 'Hide Form' : 'Create New Product'}
            </button>
            {showCreateForm && <CreateProduct />}
            <ProductList />
        </div>
    );
};

export default Product;
